/* eslint no-nested-ternary: 0 */

const checkRouterUrls = (asPath, pathname) => {
  const urlParts = asPath.includes("/?")
    ? asPath.split("/?")
    : asPath.includes("?")
    ? asPath.split("?")
    : [asPath];
  if (urlParts[0].replace(/\/$/, "") !== pathname) return urlParts.join("?");
  return null;
};

export default checkRouterUrls;
